import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';

import Table from 'modules/_shared/Table';

import EligiblesTableHeader from './EligiblesTableHeader';
import EligiblesTableBody from './EligiblesTableBody';

import { Eligible } from '../types/Eligible';

type EligiblesTableProps = {
  eligibles: Eligible[];
};

const EligiblesTable: FC<EligiblesTableProps> = ({ eligibles }) => {
  const { t } = useTranslate();
  const tableContent = (
    <>
      <EligiblesTableHeader />
      <EligiblesTableBody eligibles={eligibles} />
    </>
  );

  return (
    <div className="card card-bordered mt-3">
      <div className="card-inner card-inner-md mt-2">
        <div className="card-title-group">
          <h6 className="card-title">{t('EligiblePartnersOrBeneficiaries')}</h6>
        </div>
      </div>

      <Table content={tableContent} />
    </div>
  );
};

export default EligiblesTable;
